<div class="row d-none d-lg-block " >
  <nav class="navbar navbar-expand-lg d-none d-lg-block" style="width: 100vw">
    <div class="row sub-header">
      <div class="col-2">

      </div>
      <div class="text-center">
        <ul class="left-info text-left">
          <li><a [href]="website"><nb-icon class="mx-1" icon="clock-outline"></nb-icon>Mon-Fri 09:00am-5:00pm</a></li>
          <li><a [href]="website"><nb-icon class="mx-1" icon="phone-outline"></nb-icon>888-491-0491</a></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li><a href="https://www.facebook.com/irvingfund" target="_blank"><nb-icon icon="facebook"></nb-icon></a></li>
          <li><a href="https://www.instagram.com/irving_fund/" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512">
              <path d="M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z"/></svg>
          </a></li>
          <li><a href="https://linkedin.com/company/irvingfund" target="_blank"><nb-icon icon="linkedin"></nb-icon></a></li>
        </ul>

      </div>
    </div>
    <div class="row my-3">

      <div class="col-2">

      </div>
      <div class="text-center">

        <div class="collapse navbar-collapse" id="navbarResponsive">
          <a [href]="website"> <img src="assets/logos/Logo_horizontal02-1024x108.svg" width="170" height="20" class="img-responsive" alt="Irving Fund"  ></a>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link" href="https://irvingfund.com/howitworks">How It Works</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://irvingfund.com/Lendingoptions">Lending Options</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://irvingfund.com/Lineofcredit">Line Of Credit</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://irvingfund.com/WhyIrvingfund">Why Irving Fund</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://irvingfund.com/contact">Contact Us</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [href]='adminURL' style="color:white;" >Login</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-2 text-left">

      </div>

    </div>
  </nav>

</div>
<div class="d-lg-none full-width-div"  >

  <div class="row ">
    <div class="col-9">
      <strong class="header-font-mobile "><a [href]="website">888-491-0491</a></strong>
      <strong class="header-font-mobile mx-2"><a [href]="website">Mon-Fri 09:00am-5:00pm</a></strong>
    </div>

    <div>
      <div class="col-3 text-center">
        <button size="small" nbButton ghost [nbContextMenu]="items"><nb-icon icon="menu-outline"></nb-icon></button>
      </div>
    </div>
  </div>
  <hr >
  <div class="row ">
    <div class="col-6">
      <a [href]="website"> <img src="assets/logos/Logo_horizontal02-1024x108.svg" width="170" height="20" class="img-responsive" alt="Irving Fund"  ></a>
    </div>
    <div class="col-6 text-center">
      <a class="mx-0" href="https://www.facebook.com/irvingfund" target="_blank"><nb-icon icon="facebook"></nb-icon></a>
      <a class="mx-3" href="https://www.instagram.com/irving_fund/" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512">
          <path d="M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z"/></svg>
      </a>
      <a class="mx-2" href="https://linkedin.com/company/irvingfund" target="_blank"><nb-icon icon="linkedin"></nb-icon></a>

    </div>
  </div>
</div>

















